module.exports = __webpack_public_path__ + "2f663b7a20e282b1120d6bc6602e80e9.MP3";